module.exports = "/_next/static/images/main-visual-home-ce5bc1b3fd520dc524c93e8289cb3bfc.jpg";